import BaseModel from './BaseModel';

export default class RemainingRelevantAnalysisItemDto extends BaseModel {
  constructor(data = {}) {
    super(RemainingRelevantAnalysisItemDto, data);
    this.lowerRangeCount = data.lowerRangeCount;
    this.upperRangeCount = data.upperRangeCount;
    this.confidenceDistribution = data.confidenceDistribution;
    this.maxConfidence = data.maxConfidence;
  }
}
